import React from "react";
import { useModifyArticle } from "../config/useModifyArticle";
import ArticleFormCommon, { ArticleFormData } from "../../ui/ArticleFormCommon";
import "./ModifyArticle.scss";

const ModifyArticle = () => {
  const articleId = window.location.pathname.split("/admin/article/modify/")[1];

  const {
    formData,
    categories,
    availableKeywords,
    products,
    authors,
    loading,
    error,
    validationErrors,
    uploadingImages,
    updateFormData,
    handleCategoryChange,
    handleProductChange,
    handleKeywordChange,
    handleAuthorChange,
    handleUxEvaluationChange,
    handleDataSourceChange,
    addStudyLink,
    removeStudyLink,
    updateStudyLink,
    addImage,
    removeImage,
    updateImage,
    handleImageFileUpload,
    moveImageUp,
    moveImageDown,
    submitArticle,
  } = useModifyArticle(articleId);

  const convertToArticleFormData = (
    data: typeof formData,
  ): ArticleFormData => ({
    ...data,
    author: {
      ...data.author,
      numOfArticles: data.author.numOfArticles || 0,
    },
    product: data.product
      ? {
          ...data.product,
          numOfArticles: data.product.numOfArticles || 0,
        }
      : undefined,
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await submitArticle();
    if (success) {
      window.location.replace("/admin");
    }
  };

  if (loading) {
    return <div className="loading">로딩 중...</div>;
  }

  return (
    <div className="modify-article">
      <div className="modify-article__header">
        <h1>아티클 수정</h1>
        <p>아티클 정보를 수정하세요.</p>
      </div>

      {/* 검증 에러 메시지 표시 */}
      {Object.keys(validationErrors).length > 0 && (
        <div className="modify-article__validation-error">
          <h3>⚠️ 필수 항목을 확인해주세요</h3>
          <ul>
            {Object.entries(validationErrors).map(([field, message]) => (
              <li key={field}>{message}</li>
            ))}
          </ul>
        </div>
      )}

      {/* API 에러 메시지 표시 */}
      {error && (
        <div className="modify-article__error">
          <p>❌ {error}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="modify-article__form">
        <ArticleFormCommon
          formData={convertToArticleFormData(formData)}
          categories={categories}
          availableKeywords={availableKeywords}
          products={products}
          authors={authors}
          uploadingImages={uploadingImages}
          validationErrors={validationErrors}
          updateFormData={updateFormData}
          handleCategoryChange={handleCategoryChange}
          handleProductChange={handleProductChange}
          handleKeywordChange={handleKeywordChange}
          handleAuthorChange={handleAuthorChange}
          handleUxEvaluationChange={handleUxEvaluationChange}
          handleDataSourceChange={handleDataSourceChange}
          addStudyLink={addStudyLink}
          removeStudyLink={removeStudyLink}
          updateStudyLink={updateStudyLink}
          addImage={addImage}
          removeImage={removeImage}
          updateImage={updateImage}
          handleImageFileUpload={handleImageFileUpload}
          moveImageUp={moveImageUp}
          moveImageDown={moveImageDown}
        />

        <div className="form-actions">
          <button type="button" onClick={() => window.history.back()}>
            취소
          </button>
          <button type="submit" className="submit-btn">
            아티클 수정하기
          </button>
        </div>
      </form>
    </div>
  );
};

export default ModifyArticle;
